import { useCallback, useEffect, useRef, useState } from "react";

// const [copied, copy] = useCopyToClipboard();  copy(text) → shows "Copied" for 1.5s.
// Falls back to a prompt the reader can copy from if the clipboard is blocked.
export function useCopyToClipboard(resetMs = 1500) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), resetMs);
      return true;
    } catch {
      window.prompt("Copy this:", text);
      return false;
    }
  }, [resetMs]);

  return [copied, copy];
}
